import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page = 1, limit = 20, total = 0, onPageChange }) {
  const totalPages = Math.ceil(total / limit) || 1;

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between gap-4 mt-8 pt-6 border-t border-border" data-testid="pagination-controls">
      <p className="text-sm text-muted-foreground">
        Showing <span className="font-bold text-foreground">{(page - 1) * limit + 1}</span> to{" "}
        <span className="font-bold text-foreground">{Math.min(page * limit, total)}</span> of{" "}
        <span className="font-bold text-foreground">{total}</span> properties
      </p>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <div className="flex items-center gap-1.5" data-testid="pagination-pages">
          {[...Array(totalPages)].map((_, i) => {
            const p = i + 1;
            if (p === 1 || p === totalPages || Math.abs(p - page) <= 1) {
              return (
                <Button
                  key={p}
                  variant={p === page ? "default" : "outline"}
                  className="w-9 h-9 p-0 font-bold"
                  onClick={() => onPageChange(p)}
                  data-testid={`pagination-page-${p}`}
                >
                  {p}
                </Button>
              );
            }
            if (p === 2 || p === totalPages - 1) {
              return <span key={p} className="text-muted-foreground px-1">...</span>;
            }
            return null;
          })}
        </div>
        <Button
          variant="outline"
          size="icon"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          aria-label="Next page"
          data-testid="pagination-next"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
